import stations from 'metrostations'

import { spbMetroStations } from '../consts/spbMetroStations'

export const getColorByStationName = (stationName: string) => {
  const str1 = stationName.toLowerCase().replace(/[ёе]/g, 'е')
  const station = stations?.Moscow?.Stations?.find(
    s => s.local_name.toLowerCase().replace(/[ёе]/g, 'е') === str1
  )
  const stationSpb = spbMetroStations?.find(
    s => s.local_name.toLowerCase().replace(/[ёе]/g, 'е') === str1
  )
  const line = stations?.Moscow?.Lines?.find(s => s.id === station?.line)

  if (stationName === 'Аминьевская' || stationName === 'Очаково') {
    return '#3cb183'
  }
  if (stationName === 'Потапово') {
    return '#cf2028'
  }
  if (stationName === 'Внуково') {
    return '#FFD801'
  }
  if (stationName === 'Нижегородская') {
    return '#e13b8f'
  }
  if (stationName === 'Новохохловская') {
    return '#e13b8f'
  }
  if (stationName === 'Бутово') {
    return '#CC527A'
  }
  if (stationName === 'Щербинка') {
    return '#CC527A'
  }
  if (stationName === 'Красный Строитель') {
    return '#CC527A'
  }
  if (stationName === 'Б-р Дмитрия Донского') {
    return '#758190'
  }
  if (stationName === 'Проспект Ветеранов') {
    return '#e90101'
  }
  if (stationName === 'Аэропорт Внуково') {
    return '#ffdf05'
  }
  if (stationName === 'Зеленоград-Крюково') {
    return '#e15d29'
  }
  if (stationName === 'Лианозово') {
    return '#78c800'
  }
  if (stationName === 'Грачёвская') {
    return '#e95b0c'
  }

  return line?.color || stationSpb?.line_color
}

export const pluralize = (
  number: number,
  one: string,
  few: string,
  many: string,
  withoutNumber?: boolean
) => {
  const num = Number(number)
  if (num % 10 === 1 && num % 100 !== 11) {
    return withoutNumber ? `${one}` : `${num} ${one}`
  } else if (
    num % 10 >= 2 &&
    num % 10 <= 4 &&
    (num % 100 < 10 || num % 100 >= 20)
  ) {
    return withoutNumber ? `${few}` : `${num} ${few}`
  } else {
    return withoutNumber ? `${many}` : `${num} ${many}`
  }
}

export const formatNumberWithThousands = (number: string) => {
  const result = number
    .toString()
    .replace(/[^0-9/.]/g, '')
    .split(' ')
    .join('')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return result === '' ? '0' : result
}

export const formatStringWithThousands = (str: string) => {
  str.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export const parseNumber = (str: string): number => {
  str = str.replace(/\s/g, '')

  return +str
}

export const vc = (value: number): number => {
  const desktopXL = 1800
  const desktopBase = 1376
  const base = window.innerWidth < 1024 ? 375 : desktopBase

  return window.innerWidth < desktopXL
    ? value * (window.innerWidth / base)
    : (value * desktopXL) / desktopBase
}
